import { createSelector } from "reselect"
import { computeFactorsColumns } from "helpers/assets"
import { getSelectedMetricType, getContentSetCategoryFactors } from "."
import { getSelectedViewIsContentSet } from "selectors/contentSets"
import { getSelectedView } from "selectors/assets"
import { getModelFactors } from "selectors/modelMetadata"

const getFactors = createSelector(
  [getModelFactors, getContentSetCategoryFactors],
  (factors, contentSetFactors) => contentSetFactors || factors,
)

export const getFactorsColumns = createSelector(
  [getFactors, getSelectedView, getSelectedMetricType, getSelectedViewIsContentSet],
  computeFactorsColumns,
)
